/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_TitleInputs */

const en_gc_search_guides_gridcraft_online_sections_2_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save a file you can actually reopen`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存一个可以重新打开的文件`)
};

/**
* | output |
* | --- |
* | "Save a file you can actually reopen" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_title(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_title(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_title as "gc.search_guides.gridcraft_online.sections.2.title" }